import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=e1f96766&scoped=true&"
import script from "./ArticleList.vue?vue&type=script&lang=js&"
export * from "./ArticleList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleList.vue?vue&type=style&index=0&id=e1f96766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f96766",
  null
  
)

export default component.exports